<template>
  <div id="page-selfie">
    <div class="dicas" v-if="!isError">
      <Dicas :selfie="true"></Dicas>
    </div>
    <div class="page-content-selfie" :class="{'hidden':isError}">
      <Captura
          :esconder="esconder"
          :corElipse="corElipse"
          :tamanho-elipse="tamanhoElipse"
          :tamanho-body-elipse="tamanhoBodyElipse"
      ></Captura>
      <p class="texto-selfie txt-subtitulo">{{ textoSelfie }}</p>
      <div class="elemento-cadeado">
        <p><i class="bi bi-lock-fill"></i></p>
        <p>
          Sua imagem está segura. Ela vai ser usada apenas pra confirmar sua
          identidade
        </p>
      </div>
    </div>

    <div class="page-error margem-app">
      <Error
          v-if="isError"
          :title="error.title"
          :subtitle="error.subtitle"
          :button-text="error.btnTitle"
          v-bind:callback="this.reloadComponent"
      ></Error>
    </div>

    <ModalCamera
        v-bind:callback-confirm-button="allow"
        v-bind:callbackCloseButton="refuse"
    >
    </ModalCamera>
  </div>
</template>

<script>
import Captura from "../shared/Captura";
import AppService from "../../services/AppService";
import LoadScriptFilesService from "../../services/LoadScriptFilesService";
import Dicas from "../shared/Dicas";
import Error from "../shared/Error";
import ModalCamera from "../shared/ModalCamera";
import DispatchTags from "../../utils/DispatchTags";


const SELFIE_FILE_CSS = "@/../static/selfie/liveness2d/liveness2D.css";
export default {
  name: "Liveness2D",
  components: { ModalCamera, Error, Dicas, Captura },
  data: function () {
    return {
      corElipse: "laranja",
      tamanhoElipse: "",
      tamanhoBodyElipse: "",
      esconder: true,
      textoSelfie: "",
      isError: false,
      isSelfError: false,
      video: {
        loaded: true,
        listener: null,
      },
      error: {
        title: "Algo deu errado! Vamos tentar tirar a foto mais uma vez",
        subtitle:
            "Deixe seu rosto visível, fique num lugar com boa iluminação e depois tente de novo",
        btnTitle: "Ok, tentar de novo",
      },
    };
  },
  created() {
    this.$store.dispatch("setTitulo", "Confirmação de identidade");
    this.$store.dispatch("setLoadingStatus", true);
    this.loadExternal = new LoadScriptFilesService();
    this.appService = new AppService();
    this.tentativas = 0;
  },
  mounted() {
    var interval = setInterval(() => {
      if (!this.$store.getters.componenteSelfieCarregado) {
        return;
      }
      this.iniciaSelfie();
      this.$store.dispatch("setLoadingStatus", false);
      clearInterval(interval);
    }, 100);
  },
  beforeRouteEnter(to, from, next) {
    let l = new LoadScriptFilesService();
    l.head_link(SELFIE_FILE_CSS)
        .then(() => next())
        .catch(() => alert("Falha ao carregar arquivo"));
  },
  beforeRouteLeave(to, from, next) {
    let l = new LoadScriptFilesService();
    l.del_link(SELFIE_FILE_CSS);
    this.destroiListenerVideo();
    this.stopStream();
    next();
  },
  methods: {
    iniciaSelfie: function () {
      DispatchTags.dispatchScreenView('Selfie');
      let htmlElement = document.getElementById('selfie');
      this.selfie = window.selfie;
      var criarListener = false;
      this.selfie
          .iniciaSelfie(htmlElement, (id, mensagem) => {
            switch (id) {
              case "LOADING":
                let isLoad = mensagem === "true";
                this.$store.dispatch("setLoadingStatus", isLoad);
                if (!isLoad) {
                  this.esconder = false;
                  this.corElipse = 'azul';
                  this.corElipse = 'verde';
                }
                if (isLoad && !criarListener) {
                  this.criarListernerVideo();
                  criarListener = true;
                }
                break;
              case "ALTERA_TEXTO":
                let obj = {
                  laranja: ["aguarde um momento ...", "encaixe seu rosto"],
                  azul: [
                    "alinhe seu rosto",
                    "aproxime o rosto",
                    "afaste o rosto",
                  ],
                  verde: ["aguarde nesta posição"],
                };
                var m = mensagem.toLowerCase();
                if (obj.laranja.includes(m)) {
                  this.corElipse = "laranja";
                }
                if (obj.azul.includes(m)) {
                  this.corElipse = "azul";
                }
                if (obj.verde.includes(m)) {
                  this.corElipse = "verde";
                }

                if (m === "aguarde um momento ...") {
                  mensagem = "Aguarde um momento";
                }
                if (m === "encaixe seu rosto") {
                  mensagem = "Centralize seu rosto \n " + "dentro da moldura";
                }
                if (m === "aproxime o rosto") {
                  mensagem = "Agora aproxime o rosto";
                }
                if (m === "afaste o rosto") {
                  mensagem = "Agora afaste rosto";
                }

                if (m === "aguarde nesta posição") {
                  mensagem = "Estamos capturando sua foto";
                }

                this.textoSelfie = mensagem;
                break;
              case "AUMENTA_FRAME":
                switch (mensagem) {
                  case "SelfieTamanho.Pequeno":
                    this.tamanhoElipse = "elipseSMALL";
                    this.tamanhoBodyElipse = "elipseBODYSMALL";
                    break;
                  case "SelfieTamanho.Medio":
                    this.tamanhoElipse = "elipseMED";
                    this.tamanhoBodyElipse = "elipseBODYMED";
                    break;
                  case "SelfieTamanho.Grande":
                    this.tamanhoElipse = "elipseBIG";
                    this.tamanhoBodyElipse = "elipseBODYBIG";
                    break;
                }
                break;
            }
          })
          .then((selfie) => {
            this.textoSelfie = "Pronto!";
            this.selfie.camera.video.poster = selfie.selfie;
            $("#selfie").html(this.selfie.camera.cameraContainer);
            document
                .getElementById("bodyelipses1")
                .classList.add("concluido-selfie");
            document
                .getElementById("elipse")
                .classList.add("concluido-selfie-elipise");
            this.$store.dispatch("setLoadingStatus", false);
            sessionStorage.setItem("s", selfie.selfie);

            DispatchTags.dispatchNoninteraction('Selfie');

            return setTimeout(() => {
              this.$store.dispatch("setLoadingStatus", true);
              this.destroiListenerVideo();
              if (
                  this.$store.getters.tipoCaptura === 1 &&
                  !sessionStorage.getItem("A") &&
                  !sessionStorage.getItem("B")
              ) {
                this.$router.push({ name: "DocSelecao" });
                return;
              }
              this.$router.push({ name: "Analise" });
              return;
            }, 1000);
          })
          .catch((err) => {
            this.destroiListenerVideo();
            this.stopStream();
            this.$store.dispatch("setLoadingStatus", false);
            DispatchTags.dispatchScreenView('SelfieError');
            DispatchTags.dispatchNoninteraction('SelfieError');
            this.isError = true;
          });
    },
    stopStream() {
      if(window.selfieVideoStream) {
        window.selfieVideoStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
    },
    reloadComponent() {
      DispatchTags.dispatchInraction('SelfieError');
      this.$store.dispatch("setLoadingStatus", true);
      //o componente só volta funcionar caso de reload na pagina =D
      this.$router.replace({name:'ConfirmarIdentidade'}).then(_ => {
        this.$store.dispatch("setLoadingStatus", true);
        window.location.reload(true);
      });
    },
    criarListernerVideo() {
      this.showModalPermissaoCamera();
      this.video.listener = setInterval(() => {
        if(!window.selfieVideoStream){
          window.selfieVideoStream  =  this.selfie.camera.videoStream;
        }
        if (!this.selfie.camera.videoLoaded && this.video.loaded) {
          this.$store.dispatch("setLoadingStatus", true);
          this.video.loaded = false;
          return;
        }
        if (this.selfie.camera.videoLoaded && !this.video.loaded) {
          this.$store.dispatch("setLoadingStatus", false);
          this.video.loaded = true;
        }
      }, 100);
    },
    destroiListenerVideo: function () {
      if (null !== this.video.listener) {
        clearInterval(this.video.listener);
        this.video.listener = null;
      }
    },
    showModalPermissaoCamera: function () {
      var interval = setInterval(() => {
        var cameraVideo = document.getElementById("cameraVideo");
        if (!cameraVideo) {
          return;
        }
        cameraVideo.autoplay = true;
        cameraVideo.addEventListener("click", () => cameraVideo.play(), false);
        this.allow();
        clearInterval(interval);
      }, 100);
    },
    allow: function () {
      var $video = $(document.getElementById("cameraVideo"));
      $video.trigger("click");
      $video.css("display", "block");
      this.setErrorPadrao();
    },
    refuse: function () {
      this.setErrorPermissao();
      DispatchTags.dispatchScreenView('ModalCamera');
      this.isError = true;
      this.isCamErro = true;
    },
    setErrorPermissao() {
      this.error.title = "Algo deu errado ao acessar sua câmera";
      this.error.subtitle = "Precisamos do acesso pra tirar a foto e confirmar sua identidade";
      this.error.btnTitle = "Permitir acesso à câmera";
    },
    setErrorPadrao() {
      this.error.title =
          "Não conseguimos tirar a foto do seu rosto";
      this.error.subtitle =
          "Não localizamos seu rosto para tirar a foto. Centralize ele na moldura e tente novamente";
      this.error.btnTitle = "Tentar novamente";
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0 !important;
}
.page-content-selfie {
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  z-index: 1;
}
.texto-selfie {
  position: absolute;
  z-index: 3;
  text-align: center;
  bottom: 9.5vh;
  color: #000;
  white-space: pre-wrap;
  word-wrap: break-word;
  width: 100%;
  line-height: initial;
}
.elemento-cadeado {
  position: absolute;
  z-index: 4;
  bottom: 3vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95vw;
  padding: 1rem;
  padding-bottom: 0;
  font-size: 12px;
  line-height: initial;
  left: 50%;
  transform: translateX(-50%);
}

.elemento-cadeado p:first-child {
  margin-right: 1rem;
}

.elemento-cadeado i {
  color: #666666;
}
.hidden{
  display: none !important;
}
@media (min-width: 768px) {
  .elemento-cadeado {
    display: none;
  }
  .texto-selfie {
    left: 50%;
    transform: translateX(-50%);
  }
  .page-content-selfie {
    position: inherit !important;
    height: auto !important;
    width: 100% !important;
  }
  .elemento-cadeado {
    width: 41vw !important;
  }
}
@media (max-device-height: 640px) {
  @media (max-device-height: 640px), (max-height: 575px) {
    .elemento-cadeado {
      font-size: 10px;
    }
  }
  @media (max-device-height: 639px) {
    .dicas {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Liveness2D.vue